var render, staticRenderFns
import script from "./DiscernableContent.vue?vue&type=script&lang=js&"
export * from "./DiscernableContent.vue?vue&type=script&lang=js&"
import style0 from "./DiscernableContent.vue?vue&type=style&index=0&id=2fe3f772&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe3f772",
  null
  
)

export default component.exports